import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import { fixedTwo, formatDateTimezon } from "../common-data/Converts";
import { NoPic } from "../../exports/Images";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { delete_fitness_center } from "../../data/ApiEndpoints";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { CheckCircleIcon, CrossCircleIcon } from "../../images/icons/icons";

const FitnessCenterListings = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
  callFunction,
  userInfoData,
  onOpenDeviceIdModal,
}) => {
  const dispatch = useDispatch();
  const { fitnessCentersLoading, fitnessCenters } = useSelector(
    (state) => state.hygiene
  );

  const isAdmin = userInfoData?.account_type === "admin";

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);

  const handleDelete = async (payload, gymName) => {
    if (payload.gym_id) {
      const handleConfirm = async () => {
        const method = "PUT";
        const endpoint = delete_fitness_center;
        const token = userInfoData?.token;

        try {
          const result = await dispatch(
            commonPostPutApi({ method, endpoint, payload, token })
          );

          if (result?.payload?.status) {
            callFunction();
            toast.success(result?.payload?.message || "Success!");
          } else {
            const errorMessage =
              result?.error?.message || result?.payload?.message;
            toast.error(errorMessage || "Something Went Wrong!");
          }
        } catch (error) {
          console.error("Error making POST request:", error);
        }
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure, you want to delete ${gymName || ""}!`
      );
    } else {
      toast.error("Gym ID required!");
    }
  };

  const handleDeviceIdClick = (row) => {
    onOpenDeviceIdModal(row);
  };

  useEffect(() => {
    if (fitnessCenters?.status && fitnessCenters?.data?.length > 0) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: fitnessCenters.data,
        pagination:
          fitnessCenters?.pagination?.length > 0
            ? fitnessCenters.pagination
            : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [fitnessCenters]);

  const tbColumns = [
    {
      dataField: "gym_id",
      text: "Gym Details",
      formatter: (_, row) => (
        <div className="multi-row-table-td minWidth200">
          <small
            className="tb-data mid-padding mid-radius"
            style={{
              background: "#F64E60",
              color: "#fff",
              letterSpacing: "1px",
            }}
          >
            {row?.category_name || ""}
          </small>

          <span
            className="tb-data text-start link"
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "manage_gym",
                rowData: row,
              }));
            }}
          >
            {row?.gym_name || "NA"}
          </span>
          <div className="highlighted-dotted-line"></div>
          <b className="tb-data text-start text-initial small-text">
            {row?.slug || "-"}
          </b>
          <small className="tb-data text-start text-initial">
            {row?.address1 || ""}, {row?.address2 || ""},
          </small>
          <small className="tb-data text-start text-initial">
            {row?.city || ""}, {row?.state || ""}, {row?.pin || ""},
          </small>
        </div>
      ),
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.status === "active" ? <CheckCircleIcon/> : row?.status === "inactive" ? <CrossCircleIcon/> : (
              "-"
            )}
          </span>
        );
      },
    },
    // {
    //   dataField: "user_id",
    //   text: "Owner",
    //   formatter: (_, row) => {
    //     return <span className="tb-data minWidth100">{row?.name || "NA"}</span>;
    //   },
    // },
    {
      dataField: "is_gst_inclusive",
      text: "GST Inclusive",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_gst_inclusive ? (
             <CheckCircleIcon/>
            ) : (
              <CrossCircleIcon/>
            )}
          </span>
        );
      },
    },
    {
      dataField: "is_100",
      text: "100M Restriction",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_100 ? (
             <CheckCircleIcon/>
            ) : (
              <CrossCircleIcon/>
            )}
          </span>
        );
      },
    },
    {
      dataField: "rating",
      text: "Rating",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon minWidth60">
            {row?.rating ? (
              fixedTwo(row.rating)
            ) :  <CrossCircleIcon/>}{" "}
            {row?.rating ? "★" : null}
          </span>
        );
      },
    },
    {
      dataField: "is_pre_sale",
      text: "Pre Sale",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_pre_sale ? (
             <CheckCircleIcon/>
            ) : (
              <CrossCircleIcon/>
            )}
          </span>
        );
      },
    },
    {
      dataField: "is_dummy",
      text: "Dummy Gym",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_dummy ?  (
             <CheckCircleIcon/>
            ) : (
              <CrossCircleIcon/>
            )}
          </span>
        );
      },
    },
    {
      dataField: "allow_recurring",
      text: "Recurring Allowed",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.allow_recurring ?  (
             <CheckCircleIcon/>
            ) : (
              <CrossCircleIcon/>
            )}
          </span>
        );
      },
    },
    {
      dataField: "google_rating",
      text: "Google Rating",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.google_rating ? (
              fixedTwo(row.google_rating)
            ) :  <CrossCircleIcon/>}{" "}
            {row?.google_rating ? "★" : null}
          </span>
        );
      },
    },
    {
      dataField: "thumbnail",
      text: "thumbnail",
      formatter: (_, row) => {
        return (
          <div className="flexCenter minWidth150">
            <div className="tb-data-img">
              <img
                src={row?.thumbnail || NoPic}
                alt={row?.gym_name || "NA"}
                className="image"
                onClick={() => {
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "update_thumbnail",
                    image: row?.thumbnail || NoPic,
                    rowData: row,
                  }));
                }}
              />

              <button
                type="button"
                className="abs-zoom"
                onClick={() => {
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "thumbnail",
                    image: row?.thumbnail || NoPic,
                  }));
                }}
                disabled={!row?.thumbnail}
                style={{
                  opacity: row?.thumbnail ? "1" : "0.5",
                  cursor: row?.thumbnail ? "pointer" : "not-allowed",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrows-fullscreen"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707m0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707m-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707"
                  />
                </svg>
              </button>
              {/* <button
                type="button"
                className="abs-zoom abs-del"
                onClick={() => {
                  const uidFilter = {
                    uid: row?.banner_id || "",
                  };

                  handleDelete(uidFilter);
                }}
                disabled
                style={{
                  opacity: "0.5",
                  cursor: "not-allowed",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash3-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
                </svg>
              </button> */}
            </div>
          </div>
        );
      },
    },
    {
      dataField: "cover_image",
      text: "cover image",
      formatter: (_, row) => {
        return (
          <div className="flexCenter minWidth150">
            <div className="tb-data-img">
              <img
                src={row?.cover_image || NoPic}
                alt={row?.gym_name || "NA"}
                className="image"
                onClick={() => {
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "update_cover_image",
                    image: row?.cover_image || NoPic,
                    rowData: row,
                  }));
                }}
              />

              <button
                type="button"
                className="abs-zoom"
                onClick={() => {
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "cover_image",
                    image: row?.cover_image || NoPic,
                  }));
                }}
                disabled={!row?.cover_image}
                style={{
                  opacity: row?.cover_image ? "1" : "0.5",
                  cursor: row?.cover_image ? "pointer" : "not-allowed",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrows-fullscreen"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707m0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707m-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707"
                  />
                </svg>
                {/* <MdZoomOutMap /> */}
              </button>
              {/* <button
                type="button"
                className="abs-zoom abs-del"
                onClick={() => {
                  const uidFilter = {
                    uid: row?.banner_id || "",
                  };

                  handleDelete(uidFilter);
                }}
                disabled
                style={{
                  opacity: "0.5",
                  cursor: "not-allowed",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash3-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
                </svg>
              </button> */}
            </div>
          </div>
        );
      },
    },
    // {
    //   dataField: "gmb_url",
    //   text: "location",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data icon">
    //         {row?.gmb_url ? (
    //           <a href={row.gmb_url} target="_blank" rel="noreferrer">
    //             <svg
    //               xmlns="http://www.w3.org/2000/svg"
    //               width="16"
    //               height="16"
    //               fill="currentColor"
    //               className="bi bi-pin-map-fill"
    //               viewBox="0 0 16 16"
    //               style={{
    //                 color: "#209216",
    //                 minWidth: "35px",
    //                 minHeight: "35px",
    //               }}
    //             >
    //               <path
    //                 fillRule="evenodd"
    //                 d="M3.1 11.2a.5.5 0 0 1 .4-.2H6a.5.5 0 0 1 0 1H3.75L1.5 15h13l-2.25-3H10a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .4.2l3 4a.5.5 0 0 1-.4.8H.5a.5.5 0 0 1-.4-.8z"
    //               />
    //               <path
    //                 fillRule="evenodd"
    //                 d="M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999z"
    //               />
    //             </svg>
    //           </a>
    //         ) : (
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="16"
    //             height="16"
    //             fill="currentColor"
    //             className="bi bi-x-circle-fill"
    //             viewBox="0 0 16 16"
    //             style={{ color: "#E41815" }}
    //           >
    //             <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
    //           </svg>
    //         )}
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "gmb_url",
      text: "GMB URL",
      formatter: (_, row) => {
        return (
          <div className="flexCenter ">
            <div className="tb-data-url">
              <span
                className="tb-data link minWidth100"
                onClick={() => {
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "update_gmb_url",
                    urlValue: row?.gmb_url || "",
                    rowData: row,
                  }));
                }}
                title={row?.gmb_url || "Add GMB URL"}
              >
                {row?.gmb_url ? "View URL" : "Add GMB URL"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "short_url",
      text: "Short URL",
      formatter: (_, row) => {
        return (
          <div className="flexCenter ">
            <div className="tb-data-url">
              <span
                className="tb-data link minWidth100"
                onClick={() => {
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "update_short_url", 
                    urlValue: row?.short_url || "",
                    rowData: row,
                  }));
                }}
                title={row?.short_url || "Add Short URL"}
              >
                {row?.short_url ? "View URL" : "Add Short URL"}
              </span>
            </div>
          </div>
        );
      },
    },
    ...(userInfoData?.account_type === "admin"
      ? [
          {
            dataField: "device_id",
            text: "Device ID",
            formatter: (_, row) => {
              return (
                <span
                  className="tb-data link"
                  onClick={() => handleDeviceIdClick(row)}
                  style={{ cursor: "pointer" }}
                  title="Click to update device IDs"
                >
                  View
                </span>
              );
            },
          },
        ]
      : []),
    // {
    //   dataField: "lease_agreement",
    //   text: "Documents",
    //   formatter: (_, row) => {
    //     return (
    //       <span
    //         className="tb-data link"
    //         onClick={() =>
    //           setModValues((prevs) => ({
    //             ...prevs,
    //             isModOpen: true,
    //             modName: "all_documents",
    //             rowData: row,
    //           }))
    //         }
    //       >
    //         View
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "bank_statement",
    //   text: "Bank Details",
    //   formatter: (_, row) => {
    //     return (
    //       <span
    //         className="tb-data link"
    //         onClick={() =>
    //           setModValues((prevs) => ({
    //             ...prevs,
    //             isModOpen: true,
    //             modName: "bank_statement",
    //             rowData: row,
    //           }))
    //         }
    //       >
    //         View
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "date_added",
    //   text: "Date Added",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data minWidth100">
    //         {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div
          className="actionButtonContainer"
          style={{
            flexDirection: "column",
            justifyContent: "center",
            gap: "0",
          }}
        >
          <button
            className="actionBtn icon"
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                rowData: row,
              }));
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-eye-fill"
              viewBox="0 0 16 16"
            >
              <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
              <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
            </svg>
          </button>
          <button
            className="actionBtn icon qr"
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "checkin_qr_code",
                rowData: row,
              }));
            }}
          >
            <svg
              className="MuiSvgIcon-root"
              focusable="false"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z"></path>
            </svg>
          </button>
          {isAdmin && (
            <button
              className="actionBtn icon edit"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "edit",
                  rowData: row,
                }))
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
              >
                <path
                  d="M3.62891 17.3603V20.3254C3.62891 20.5985 3.84349 20.8131 4.1166 20.8131H7.08175C7.20855 20.8131 7.33535 20.7643 7.42313 20.6668L18.0743 10.0254L14.4166 6.36775L3.77521 17.0091C3.67768 17.1067 3.62891 17.2237 3.62891 17.3603ZM20.9029 7.19682C20.9933 7.10658 21.065 6.9994 21.114 6.88141C21.1629 6.76341 21.1881 6.63692 21.1881 6.50918C21.1881 6.38143 21.1629 6.25495 21.114 6.13695C21.065 6.01896 20.9933 5.91177 20.9029 5.82154L18.6205 3.53915C18.5302 3.44873 18.4231 3.37699 18.3051 3.32805C18.1871 3.2791 18.0606 3.25391 17.9328 3.25391C17.8051 3.25391 17.6786 3.2791 17.5606 3.32805C17.4426 3.37699 17.3354 3.44873 17.2452 3.53915L15.4603 5.32409L19.1179 8.98176L20.9029 7.19682Z"
                  fill="url(#paint0_linear_14023_4477)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_14023_4477"
                    x1="3.62891"
                    y1="11.6344"
                    x2="21.1881"
                    y2="11.6344"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.0447915" stopColor="#B4000B" />
                    <stop offset="1" stopColor="#DD0000" />
                  </linearGradient>
                </defs>
              </svg>
            </button>
          )}
          {isAdmin && (
            <button
              className="actionBtn icon delete"
              onClick={(e) => {
                const filters = {
                  gym_id: row?.gym_id || "",
                };
                handleDelete(filters, row?.gym_name);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
              >
                <path
                  d="M8.49846 4.3041H11.4978C11.4978 3.90637 11.3398 3.52492 11.0585 3.24369C10.7773 2.96245 10.3958 2.80445 9.99811 2.80445C9.60038 2.80445 9.21893 2.96245 8.9377 3.24369C8.65646 3.52492 8.49846 3.90637 8.49846 4.3041ZM7.4987 4.3041C7.4987 3.64121 7.76203 3.00548 8.23076 2.53675C8.69949 2.06802 9.33522 1.80469 9.99811 1.80469C10.661 1.80469 11.2967 2.06802 11.7655 2.53675C12.2342 3.00548 12.4975 3.64121 12.4975 4.3041H17.4963C17.6289 4.3041 17.7561 4.35676 17.8498 4.45051C17.9435 4.54425 17.9962 4.6714 17.9962 4.80398C17.9962 4.93655 17.9435 5.0637 17.8498 5.15745C17.7561 5.25119 17.6289 5.30386 17.4963 5.30386H16.4426L15.2489 15.6454C15.1645 16.3764 14.8143 17.0509 14.265 17.5405C13.7156 18.0302 13.0054 18.3007 12.2696 18.3008H7.72664C6.99077 18.3007 6.2806 18.0302 5.73125 17.5405C5.18191 17.0509 4.83173 16.3764 4.74735 15.6454L3.55363 5.30386H2.49988C2.3673 5.30386 2.24016 5.25119 2.14641 5.15745C2.05267 5.0637 2 4.93655 2 4.80398C2 4.6714 2.05267 4.54425 2.14641 4.45051C2.24016 4.35676 2.3673 4.3041 2.49988 4.3041H7.4987ZM8.99834 8.30315C8.99834 8.17057 8.94568 8.04343 8.85193 7.94968C8.75819 7.85593 8.63104 7.80327 8.49846 7.80327C8.36588 7.80327 8.23874 7.85593 8.14499 7.94968C8.05125 8.04343 7.99858 8.17057 7.99858 8.30315V14.3017C7.99858 14.4343 8.05125 14.5615 8.14499 14.6552C8.23874 14.7489 8.36588 14.8016 8.49846 14.8016C8.63104 14.8016 8.75819 14.7489 8.85193 14.6552C8.94568 14.5615 8.99834 14.4343 8.99834 14.3017V8.30315ZM11.4978 7.80327C11.3652 7.80327 11.238 7.85593 11.1443 7.94968C11.0505 8.04343 10.9979 8.17057 10.9979 8.30315V14.3017C10.9979 14.4343 11.0505 14.5615 11.1443 14.6552C11.238 14.7489 11.3652 14.8016 11.4978 14.8016C11.6303 14.8016 11.7575 14.7489 11.8512 14.6552C11.945 14.5615 11.9976 14.4343 11.9976 14.3017V8.30315C11.9976 8.17057 11.945 8.04343 11.8512 7.94968C11.7575 7.85593 11.6303 7.80327 11.4978 7.80327Z"
                  fill="black"
                />
              </svg>
            </button>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
      {fitnessCentersLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <PaymentLinkTable
          tableData={allDatas.allData}
          tableColumns={tbColumns}
          tablePagination={allDatas.pagination}
          isPage={isPage}
          setIsPage={(value) => setIsPage(value)}
          isFirstColSticky={true}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      )}
    </div>
  );
};

export default FitnessCenterListings;
